import React from 'react';
import { Chart, Axis, Geom, Tooltip } from 'bizcharts';
import { Card, Empty } from 'antd';
import { radius, shadow, text, fontSize as fontSizeTokens } from '../../configs/designTokens';
import useResponsiveTask from '../../hooks/useResponsiveTask';

const AnalyticsTrendChart = ({ data, loading }) => {
  const { isMobile } = useResponsiveTask();

  if (!loading && (!data || data.length === 0)) {
    return (
      <Card
        title="Daily Trend (Tasks Created)"
        style={{ borderRadius: radius.lg, boxShadow: shadow.sm }}
        headStyle={{ fontSize: fontSizeTokens.subhead, fontWeight: 600, borderBottom: 'none' }}
      >
        <Empty description="No data for selected period" />
      </Card>
    );
  }

  // Use year in labels when the data spans more than 90 days
  const spanDays = data && data.length > 1
    ? Math.round((new Date(data[data.length - 1].date) - new Date(data[0].date)) / 86400000)
    : 0;
  const dateMask = spanDays > 90 ? 'MMM DD, YYYY' : 'MMM DD';

  const scale = {
    date: {
      type: 'time',
      mask: dateMask,
      tickCount: isMobile ? 5 : 10,
    },
    created: {
      min: 0,
      alias: 'Tasks Created',
    },
  };

  return (
    <Card
      title="Daily Trend (Tasks Created)"
      style={{ borderRadius: radius.lg, boxShadow: shadow.sm, marginBottom: 16 }}
      headStyle={{ fontSize: fontSizeTokens.subhead, fontWeight: 600, borderBottom: 'none' }}
      bodyStyle={{ paddingLeft: 0, paddingRight: 0 }}
      loading={loading}
    >
      <Chart
        forceFit
        height={isMobile ? 280 : 400}
        data={data || []}
        scale={scale}
        padding={[20, 30, 60, 50]}
      >
        <Axis
          name="date"
          label={{
            style: { fontSize: 11, fill: text.secondary },
            rotate: isMobile ? -45 : 0,
          }}
        />
        <Axis
          name="created"
          label={{
            style: { fontSize: 12, fill: text.secondary },
          }}
        />
        <Tooltip crosshairs={{ type: 'y' }} />
        <Geom
          type="area"
          position="date*created"
          color="#3b82f6"
          style={{ fillOpacity: 0.15 }}
          shape="smooth"
        />
        <Geom
          type="line"
          position="date*created"
          color="#3b82f6"
          size={2}
          shape="smooth"
        />
        <Geom
          type="point"
          position="date*created"
          color="#3b82f6"
          size={3}
          shape="circle"
          style={{ stroke: '#fff', lineWidth: 1 }}
        />
      </Chart>
    </Card>
  );
};

export default AnalyticsTrendChart;
